import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import CompanyHeader from 'src/components/CompanyHeader'
import TrackDrawer from 'src/components/TrackDrawer/TrackDrawer'
import useVisibilityState from 'src/hooks/useVisibilityState'
import {
  useGetDeliveryDetails,
  useProductTags,
  useProducts,
} from 'src/services/api/queries/queries'
import { colors } from 'src/theme/colors'
import { Delivery } from 'src/types/types'
import getPersonalizedSender from 'src/utils/company'
import ProductList from '../ProductsPage/components/ProductList'
import TrackingDetails from './components/TrackingDetails'

export const TrackingPage = () => {
  const { trackingId } = useParams<{ trackingId: string }>()
  const { data: delivery = {} as Delivery } = useGetDeliveryDetails(trackingId)
  const { data: tags } = useProductTags({
    searchTerm: delivery.sender,
  })
  const [isDrawerVisible, showDrawer, hideDrawer] = useVisibilityState()

  const senderTag = tags.find((tag) => tag.name.toString() === delivery.sender)
  const { t } = useTranslation()

  const {
    data: products,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useProducts({
    searchTerm: '',
    orderBy: 'menu_order',
    order: 'asc',
    perPage: 100,
    filters: {
      tag: [senderTag?.id],
    },
  })

  return (
    <>
      <Box p={100}>
        <CompanyHeader sender={getPersonalizedSender(delivery.sender)} />
        <Text fontSize='2xl' fontWeight='bold' color={colors.primary} mb={6}>
          {t('delivery.deliveryInfo')}
        </Text>
        <TrackingDetails data={delivery} onTrackDelivery={showDrawer} />
        <ProductList
          products={products}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          loadMore={fetchNextPage}
        />
      </Box>
      <TrackDrawer
        isDrawerVisible={isDrawerVisible}
        hideDrawer={hideDrawer}
        trackingLink={delivery.tracking_link}
      />
    </>
  )
}

export default TrackingPage
